import { defineStore } from 'pinia'
import { useAppStore } from './appStore'
import { api } from '../services/api'
import router from '../router'
import { useToast } from 'vuestic-ui'

export const useUserStore = defineStore('user', {
  state: () => ({
    user: localStorage.getItem('user@lifetenant') ? JSON.parse(<string>localStorage.getItem('user@lifetenant')) : {},
    token: localStorage.getItem('token@lifeatenant') ? localStorage.getItem('token@lifeatenant') : '',
  }),

  getters: {
    userName: (state) => state.user?.name ?? '',
    email: (state) => state.user?.email ?? '',
  },

  actions: {
    async signIn(formData: { email: string; password: string }) {
      const appStore = useAppStore()

      appStore.toggleLoading(true)
      try {
        const response = await api.post(`/auth/tenant/sign-in`, {
          email: formData.email,
          password: formData.password,
        })

        this.user = response.data.tenant
        this.token = response.data.token

        localStorage.setItem('token@lifeatenant', response.data.token)
        localStorage.setItem('user@lifetenant', JSON.stringify(response.data.tenant))

        await router.push({ name: 'dashboard' })
      } catch (e: any) {
        const { init } = useToast()
        if (e?.response?.data?.message) {
          init({ message: e.response.data.message, color: 'danger' })
        } else {
          init({ message: e.message, color: 'danger' })
        }
      } finally {
        appStore.toggleLoading(false)
      }
    },
    async logout() {
      localStorage.removeItem('token@lifeatenant')
      localStorage.removeItem('user@lifetenant')
      this.user = {}
      this.token = ''

      await router.push({ name: 'login' })
    },
  },
})
